import React, { useState } from 'react';
import { MapPinIcon, TruckIcon, PhoneIcon } from 'lucide-react';
import { serviceAreaLocations, PHONE_DISPLAY, PHONE_HREF } from '../data/content';
import { ServiceAreaMap } from './ServiceAreaMap';
export function ServiceAreas() {
  const [selectedName, setSelectedName] = useState(serviceAreaLocations[0].name);
  const selected = serviceAreaLocations.find(area => area.name === selectedName) ?? serviceAreaLocations[0];
  return <section id="service-areas" className="w-full bg-white py-16 lg:py-24" data-id="element-336" data-mp="2bugowutcuxyp">
      <div className="mx-auto max-w-6xl px-5" data-id="element-337" data-mp="2gs9wnsab4013">
        <div className="max-w-2xl" data-id="element-338" data-mp="22rpcossnny60">
          <p className="font-display text-sm uppercase tracking-[0.2em] text-ember-600" data-id="element-339" data-mp="22sqx3nvk9x0e">
            Where we haul
          </p>
          <h2 className="mt-2 font-display text-3xl uppercase leading-tight text-forest-800 sm:text-4xl" data-id="element-340" data-mp="26tkl0h907bta">
            Serving all of North County San Diego
          </h2>
          <p className="mt-3 text-lg text-ink-700" data-id="element-341" data-mp="50wbxr9ohu5l">
            Pick your city on the map or in the list — we&apos;re on these streets every day, so
            getting to you doesn&apos;t take a week of scheduling.
          </p>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-[0.8fr_1.2fr]" data-id="element-342" data-mp="193ldnnlhaec">
          <div data-id="element-343" data-mp="fzawfib9vr50">
            <ul className="grid grid-cols-2 gap-2" aria-label="Service areas" data-id="element-344" data-mp="g1x0v92v9qj0">
              {serviceAreaLocations.map(area => {
              const isSelected = area.name === selected.name;
              return <li key={area.name} data-id="element-345" data-mp="3ehhl6a37hgko">
                    <button type="button" aria-pressed={isSelected} onClick={() => setSelectedName(area.name)} className={`flex w-full items-center gap-2 rounded-md px-4 py-3 text-left text-base font-semibold transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-forest-800 ${isSelected ? 'bg-forest-800 text-white' : 'bg-forest-50 text-forest-800 hover:bg-forest-100'}`} data-id="element-346" data-mp="3eij3mzmjx5cf">
                      <MapPinIcon className={`h-4 w-4 shrink-0 ${isSelected ? 'text-ember-500' : 'text-ember-600'}`} aria-hidden="true" data-id="element-347" data-mp="1fpv5xojg88pk" />
                      {area.name}
                    </button>
                  </li>;
            })}
            </ul>

            <div className="mt-5 rounded-lg border border-forest-100 bg-forest-50 p-5" data-id="element-348" data-mp="x1hrmvu55uiq">
              <p className="font-display text-xl uppercase text-forest-800" data-id="element-349" data-mp="11yqbr1yuo8mm">
                Junk removal in {selected.name}
              </p>
              <p className="mt-1 text-base text-ink-700" data-id="element-350" data-mp="9bneed5wu3xy">{selected.note}</p>
              <a href={PHONE_HREF} className="mt-4 inline-flex items-center gap-2 rounded-md bg-ember-500 px-5 py-2.5 font-display text-base uppercase tracking-wide text-ink-900 transition-colors duration-150 ease-out hover:bg-ember-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-forest-800" data-id="element-351" data-mp="99jes7f1nr3h">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-352" data-mp="2ij8ze7q72yfs" />
                {PHONE_DISPLAY}
              </a>
            </div>

            <p className="mt-5 flex items-start gap-3 text-base text-ink-700" data-id="element-353" data-mp="2dkz5s1k4c5wa">
              <TruckIcon className="mt-0.5 h-5 w-5 shrink-0 text-forest-700" aria-hidden="true" data-id="element-354" data-mp="28mxif4fntkf0" />
              Just outside these towns? Call anyway — if we can get the trailer there, we will.
            </p>
          </div>

          <ServiceAreaMap areas={serviceAreaLocations} selected={selected} onSelect={area => setSelectedName(area.name)} data-id="element-355" data-mp="1zrpzi9rgw0hz" />
        </div>
      </div>
    </section>;
}